'use client'

import React from 'react'
import Link from 'next/link'
import { Trans, useTranslation } from 'react-i18next'
import { Faq, type FaqItem } from '../../components/site/faq'
import { Reveal } from '../../components/site/reveal'
import { SectionHead } from '../../components/site/section-head'
import { SiteSection } from '../../components/site/section'
import { trackSiteLinkClicked } from '@/lib/analytics'

/** 九題。扁平的 qN／aN，理由同語音輸入頁：陣列在 key parity 測試裡是單一 leaf。 */
const QUESTION_KEYS = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6', 'q7', 'q8', 'q9']

export function TranscriptionFaqSection() {
  const { t } = useTranslation(['web'])

  const items: FaqItem[] = QUESTION_KEYS.map((key) => ({
    key,
    question: t(`web:transcriptionPage.faq.${key}`),
    answers: [
      <Trans
        key={key}
        t={t}
        i18nKey={`web:transcriptionPage.faq.${key.replace('q', 'a')}`}
        components={{
          meetingNotes: (
            <Link
              href="/meeting-notes"
              onClick={() => trackSiteLinkClicked('faq', '/meeting-notes')}
              className="border-b border-border text-foreground transition-colors hover:border-foreground"
            />
          ),
        }}
      />,
    ],
  }))

  return (
    <SiteSection id="faq" trackingKey="faq">
      <Reveal>
        <SectionHead
          eyebrow={t('web:transcriptionPage.faq.eyebrow')}
          titleKey="web:transcriptionPage.faq.title"
        />
      </Reveal>
      <Reveal className="mt-(--gap-lg)">
        <Faq items={items} />
      </Reveal>
    </SiteSection>
  )
}
